import styled from 'styled-components'

const MyDiv = styled.div`
.page_heading {
    margin-bottom: 16px;
  }

  .flex_header {
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
    .filter_section {
    display: flex;
    gap: 10px;
  }
 .btn {
    background:rgba(0, 104, 56, 1);
    color:white;
    &:hover{
    background:rgba(0, 104, 56, 1);
    color:white;
  }
}
   .job {
    text-decoration: underline;
    color: rgba(0, 122, 255, 1);
    display: inline-flex;
    align-items: center;
    padding: 4px 8px; 
    border-radius: 16px;
    white-space: nowrap; 
    cursor: pointer;
  }
 .card_box {
  background: white;
  border-radius: 12px;
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.15));
  width: auto;
}
  .donut-chart {
    width: 280px;
    height: 250px;
  }
.card-wrapper{
    background: #EEF3FB;
    border-radius: 8px;
}
.legend-row {
    width: 100%;
  }
  .legend-list:hover::-webkit-scrollbar-thumb {
    background: #a0aec0;
  }

  .legend-list::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 12px;
  }
`
export default MyDiv
